import { message, notification } from "antd";
import {
  APIResponseStatus,
  ServiceEntitlementActions,
} from "../Constants/Constants";
import { convertEntitlementFormToApiValues } from "../Helpers/ServiceEntitlementHelpers";
import { apiCallback } from "./Common";

const getMessage = (action, success) => {
  if (success) {
    return `Service Entitlement ${
      action === ServiceEntitlementActions.add ? "added" : "updated"
    } successfully!`;
  }
  return `Error ${
    action === ServiceEntitlementActions.add ? "adding" : "updating"
  } Service Entitlement`;
};

export const onFormSubmit =
  ({ props, setProcessing, setInitialValues }) =>
  (values) => {
    const {
      history,
      action,
      record,
      serviceProviderRecord,
      serviceEntitlementApi,
    } = props;
    console.log("form onSubmit", values, props);
    const failMessage = getMessage(action, false);
    const successMsg = getMessage(action, true);
    const formSubmitCallback = apiCallback({
      history,
      preProcess: () => setProcessing(false),
      errorCallback: () => message.error(failMessage),
      successCallback: (data) => {
        if (data.status === APIResponseStatus.fail) {
          if (data.info.includes("Duplicate-Entitlement-Name")) {
            notification["error"]({
              message: `Error creating Service Entitlement`,
              description: `Service Entitlement name already exist.`,
            });
          } else {
            message.error(failMessage);
          }
        } else {
          setInitialValues(values);
          message.success(successMsg);
          props.onSubmit({
            redirect: action === ServiceEntitlementActions.add,
          });
        }
      },
    });
    try {
      setProcessing(true);
      values.providerId = serviceProviderRecord?.providerId;
      values.entitlementId = record?.entitlementId;
      values.deviceModelId = record ? record.deviceModelId : values.deviceModel;
      values.serviceTierId = record ? record.serviceTierId : values.serviceTier;
      const formattedData = convertEntitlementFormToApiValues(values, action);
      console.log("onSubmit formattedData", formattedData);
      if (action === ServiceEntitlementActions.add) {
        serviceEntitlementApi.createServiceEntitlement(
          formattedData,
          formSubmitCallback
        );
      } else {
        serviceEntitlementApi.updateServiceEntitlement(
          formattedData,
          formSubmitCallback
        );
      }
    } catch (error) {
      message.error(failMessage);
      setProcessing(false);
    }
  };
